import React, { useState, useEffect } from "react"
import AssignmentRule from "../../state/assignment-rule/AssignmentRule"
import { FormattedMessage } from "react-intl"
import DeprecatedUserSelect from "../../common/user/selection.component.jsx"
import AssignmentRuleService from "../../state/assignment-rule/AssignmentRuleService"
import { isError } from "../../state/helpers/Error"
import EventBus from "../../common/EventBus.js"
import { ASSIGNMENT_KEY_REQUEST_A_QUOTE } from "../../state/assignment-rule/AssignmentRuleKeys"
import Toggle from "react-toggle"

const LabelMapping = {
    [ASSIGNMENT_KEY_REQUEST_A_QUOTE]: <FormattedMessage
        id="setting.automation.assign_rules.request_a_quote.label"
        defaultMessage="Request a quote"
    />
}

const DescriptionMapping = {
    [ASSIGNMENT_KEY_REQUEST_A_QUOTE]: <FormattedMessage
        id="settings.account.form.edit.users_round_robin_description"
        defaultMessage={"Requested quotes from an external source will be assigned " +
            "to one of the listed users with a round robin strategy"}
    />
}

const NotifyAllMapping = {
    [ASSIGNMENT_KEY_REQUEST_A_QUOTE]: <FormattedMessage
        id="settings.automation.assign_rules.request_a_quote.notify_all"
        defaultMessage="Notify all users listed"
    />
}

type OwnProps = {
    assignmentRule: AssignmentRule
}

const AssignmentRuleComponent = (props: OwnProps) => {

    const [selectedUserIds, setSelectedUserIds] = useState<string[]>(props.assignmentRule.getUserIds())
    const [isDirty, setIsDirty] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<string>("")
    const [notifyAll, setNotifyAll] = useState<boolean>(props.assignmentRule.getNotifyAll())

    useEffect(() => {
        if (!isDirty) {
            return
        }

        AssignmentRuleService.UpdateAssignmentRule(props.assignmentRule.getAssignmentKey(), selectedUserIds, notifyAll)
            .then(res => {
                if (!isError(res)) {
                    EventBus.dispatch(EventBus.TopicSendSuccessNotification, {
                        message: <FormattedMessage
                            id='setting.automation.assign_rules.update_success.message'
                            defaultMessage="Assignment rule for '{label}' updated successfully"
                            values={{
                                label: LabelMapping[props.assignmentRule.getAssignmentKey()]
                            }}
                        />
                    })
                } else {
                    setErrorMessage(res.message)
                }
            })

        setIsDirty(false)
    }, [isDirty])


    return <div className="px-3 py-2 border rounded w-100">
        <div className="mb-1">
            {LabelMapping[props.assignmentRule.getAssignmentKey()]}
            {errorMessage &&
                <p className="text-danger">{errorMessage}</p>
            }
        </div>
        <div className="input-group mb-1">
            <DeprecatedUserSelect
                value={selectedUserIds}
                multi={true}
                clearable={false}
                style={{ minWidth: "300px" }}
                onChange={(userIds) => {
                    setSelectedUserIds(userIds)
                }}
                onBlur={() => {
                    setErrorMessage("")
                    setIsDirty(true)
                }}
            />
        </div>
        <small className="form-text text-muted mt-1">
            {DescriptionMapping[props.assignmentRule.getAssignmentKey()]}
        </small>
        <div className="input-group mb-1 d-flex pt-2" style={{ gap: "12px" }}>
            {NotifyAllMapping[props.assignmentRule.getAssignmentKey()]}
            <Toggle
                icons={false}
                checked={notifyAll}
                onChange={() => {
                    setNotifyAll(prevState => !prevState)
                    setIsDirty(true)
                }}
            />
        </div>
    </div>
}



export default AssignmentRuleComponent


// WEBPACK FOOTER //
// ./src/automation/components/AssignmentRuleComponent.tsx